export class ServerFail extends Error {
  constructor(message) {
    super(message);
    this.name = "ServerFail";
  }
}
